module.exports = __webpack_public_path__ + "static/media/leaves-upsp.55fe3bab.jpg";